<template>
    <div class="onboarding-container">
        <div class="onboarding-summary-card">
            <a class="close" v-if="progressPercent == 0 && enableDismiss" href="#" @click.prevent="dismissAccountSetup" title="Dismiss Account Setup"><icon name="faCircleXmark" type="solid"></icon></a>
            <a href="/accounts/setup/fleet" :title="progressTitle" :aria-label="progressTitle" class="summary-icon">
                <icon class="title-icon" name="faClipboardCheck" type="solid"></icon>
                <span>{{ progressTitle }}</span>
            </a>
            <a v-if="progressPercent > 0" href="/accounts/setup/fleet" :title="progressTitle" :aria-label="progressTitle" class="progress-row" style="height: 25px;">
                <div class="progress-bar">
                    <div class="progress-fill" :style="{ width: `${progressPercent}%` }"></div>
                </div>
                <span style="margin-left: 10px;">
                    <small>{{progressPercent}}%</small>
                </span>
            </a>
            <a v-if="progressPercent == 0" href="/accounts/setup/fleet" :title="progressTitle" :aria-label="progressTitle" class="progress-row" style="height: 25px;">
                <span style="margin-left: 10px;">
                    <small>Free 3-month Fleet Subscription!</small>
                </span>
            </a>
        </div>
    </div>
</template>

<script>
    import script from './SetupProgress';
    export default script;</script>

<style lang="less">
    @import "./SetupProgress.less";
</style>